export default '/static/frontend/ReachDigital/12gobiking/dist/assets/klarna-pay-later-f4d30d9b.svg'